// ImageUtils.js
import React, { useState, useEffect } from 'react';
const placeholderImageUrl = 'https://via.placeholder.com/350x250';

const ImageComponent = ({ imageUrl }) => {
    const [base64Image, setBase64Image] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const response = await fetch(imageUrl);
                if (!response.ok) {
                    throw new Error(`EEEEEEFailed to fetch image, status: ${response.status}`);
                }
                // console.log("EEEEEFailed", response)

                const blob = await response.blob();
                // console.log("EEEEBlob:", blob);

                const reader = new FileReader();
                // console.log(reader, "EEEErender")
                reader.onloadend = () => {
                    // console.log("EEEEEReaderresult:", reader.result);
                    setBase64Image(reader.result);
                };

                reader.readAsDataURL(blob);
            } catch (error) {
                console.error('EEEEEError loading image:', error);
            }
        };

        loadImage();
    }, [imageUrl]);

    return (
        <img
            src={base64Image}
            // alt="Attachment is not available"
            style={{
                height: 70,
                width: 70,
                borderRadius: '10px',
                maxHeight: { xs: 233, md: 167 },
                maxWidth: { xs: 350, md: 250 },
            }}
        />
    );
};

export default ImageComponent;
